<ng-container *ngIf="!loading">
  <div class="p-fluid">
    <div class="field">
      <label class="font-medium required-field">Метод</label>
      <crm-single-select
        [options]="availableMethods"
        [(selectedItem)]="form.method"
        [isTemplateCombined]="true"
        [disabled]="availableMethodsLoading"
        optionValue="name"
        placeholder="Метод"
        appendTo="body">
        <ng-template
          #itemTemplate
          let-type="item">
          {{ type.value }}
        </ng-template>
      </crm-single-select>
    </div>

    <div class="field">
      <label class="font-medium">Параметры</label>
      <textarea
        pInputTextarea
        [(ngModel)]="form.params"
        rows="5"
        [autoResize]="false"></textarea>
    </div>

    <div
      *ngIf="result?.length"
      class="field">
      <label class="font-medium">Ответ</label>

      <textarea
        pInputTextarea
        [(ngModel)]="result"
        rows="5"
        [disabled]="true"
        [autoResize]="false"></textarea>
    </div>
  </div>

  <div class="flex align-items-center justify-content-between gap-3">
    <crm-button
      *ngIf="canWriteCompanyErp1C"
      label="Отправить"
      styleClass="p-button-success"
      [disabled]="!form.method?.length"
      (onClick)="send()"></crm-button>

    <crm-button
      type="button"
      icon="pi pi-copy"
      label="Скопировать ответ"
      styleClass="p-button-warning p-button-text"
      (onClick)="copyResult()"></crm-button>

    <crm-button
      *ngIf="result?.length"
      label="Очистить"
      icon="pi pi-undo"
      styleClass="p-button-text p-button-secondary"
      (onClick)="result = ''"></crm-button>
  </div>
</ng-container>

<crm-spinner *ngIf="loading"></crm-spinner>
